import briefcaseTool from '../tools/briefcase';
/*eslint-disable */
import noteTool from '../tools/notes';
import schedulerTool from '../tools/schedulerData/';
import todoTool from '../tools/todo-app';
export default {
  name: 'workspace-right-sidebar',
  components: {
    'notes-tool' : noteTool,
    'briefcase-tool' : briefcaseTool,
    'scheduler-tool' : schedulerTool,
    'todo-tool' : todoTool
  },
  props: [],
  data () {
    return {
      wsToolState:'notes'
    }
  },
  computed: {

  },
  mounted () {

  },
  methods: {
    wsToolsChangeMethod(val){
      this.wsToolState = val
    }
  }
}


